export const summarizeBulkUpdateResults = (results = []) => {
  const succeeded = results.filter((result) => result.status === 'fulfilled').length;
  return { succeeded, failed: results.length - succeeded, total: results.length };
};

export const applyBulkShippingUpdates = async (rows = [], payload, updateShipping) =>
  Promise.allSettled(
    rows.map((row) => Promise.resolve().then(() => updateShipping(row.id, payload)))
  );
